import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase, FilteredCommand, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { MessageService } from '../../../core/service/message.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { InvoiceService } from '../data/invoice.service';
import { Observable } from 'rxjs';
import { Invoice } from '../../model/invoice';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { DeliverInvoiceReminderComponent } from '../../component/deliver-invoice-reminder/deliver-invoice-reminder.component';

@Injectable()
export class ReminderInvoiceCommandHandler implements ICommandHandler {
  constructor(
    private _service: InvoiceService,
    private _dialogService: ActionWindowService,
    private _injector: Injector,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      if (!command.context.attestedDate || !command.context.attestedDate.hasValue()) {
        this._messageService.showMessage('INVOICE.INFORMATION_TEXT.INVOICE_CERTIFIED_BEFORE_SEND_REMINDER');
        return false;
      }
      return command.id === invoiceCommand.createReminder;
    }

    if (command instanceof MultiselectCommand) {
      return command.items.length > 0;
    }

    if (command instanceof FilteredCommand) {
      return command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      return this._dialogService.open(DeliverInvoiceReminderComponent, this._injector, null, { invoices: [command.context] }).pipe(
        map(result => {
          Object.assign(command.context, result);
          return true;
        })
      );
    }

    if (command instanceof MultiselectCommand) {
      return this._service.createReminderMany(command.items.map(item => item.id)).pipe(
        map(data => {
          command.items.forEach(item => {
            item.selected = false;
            Object.assign(
              item,
              data.find(x => x.id === item.id)
            );
          });
          return true;
        })
      );
    }
    if (command instanceof FilteredCommand) {
      return this._service
        .createReminderForFilter(
          command.filterProvider.filterState,
          command.includedIds,
          command.excludedIds,
          command.totalAffectedItemsControlValue
        )
        .pipe(map(() => true));
    }
  }
}
